import React, { Fragment, useState, useEffect } from "react";
import { reportImg } from "../Elite/imageAssets";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import activityLogService from "../../services/ActivityLog/activity-log-service";

const initialCardData = [
  {
    name: "Design",
    imageUrl: reportImg,
    pageUrl: "/MIS/design",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Sales",
    imageUrl: reportImg,
    pageUrl: "/MIS/sales",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Audit & Training",
    imageUrl: reportImg,
    pageUrl: "/MIS/auditTraining",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Insurance",
    imageUrl: reportImg,
    pageUrl: "/MIS/insurance",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Dispatch",
    imageUrl: reportImg,
    pageUrl: "/MIS/dispatch",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "PPC-1",
    imageUrl: reportImg,
    pageUrl: "/MIS/ppc-1",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Lead & Enquiry Overview",
    imageUrl: reportImg,
    pageUrl: "/MIS/leadEnquiry",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: " HR Recruitment Analysis",
    imageUrl: reportImg,
    pageUrl: "/MIS/recruitment",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "HR Attendance Analysis",
    imageUrl: reportImg,
    pageUrl: "/MIS/attendance",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Purchase",
    imageUrl: reportImg,
    pageUrl: "/MIS/purchase",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Looms",
    imageUrl: reportImg,
    pageUrl: "/MIS/looms",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Tape",
    imageUrl: reportImg,
    pageUrl: "/MIS/tape",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "ITC-4",
    imageUrl: reportImg,
    pageUrl: "/MIS/itc4",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "EX - Lamination",
    imageUrl: reportImg,
    pageUrl: "/MIS/ex-lamination",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Finishing-1",
    imageUrl: reportImg,
    pageUrl: "/MIS/finishing-1",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Finishing-2",
    imageUrl: reportImg,
    pageUrl: "/MIS/finishing-2",
    isHoverCard: false,
    isVisible: false,
  },
  {
    name: "Gravure",
    imageUrl: reportImg,
    pageUrl: "/MIS/gravure",
    isHoverCard: false,
    isVisible: false,
  },
];

const MISDashboard = () => {
  const navigate = useNavigate();
  const userApps = useSelector(
    (state) => state.loginReducer.loginDetials.userApplications,
  );
  const [cardData, setCardData] = useState(initialCardData);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (userApps && userApps.length > 0) {
      // Find the MIS Dashboard app (by ID or by name)
      const misApp =
        userApps.find(
          (x) =>
            x.aP_Id === 14 ||
            x.aP_Name.toLowerCase().includes("mis - dashboard"),
        ) || {};

      const tempMISData = misApp.features || [];

      const updatedMISCardData = initialCardData.map((card) => {
        const cardName = card.name.toLowerCase();

        const hasDesign = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("design"),
        );
        const hasSales = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("sales"),
        );
        const hasAuditTraining = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("audit"),
        );
        const hasInsurance = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("insurance"),
        );
        const hasDispatch = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("dispatch"),
        );
        const hasPPC1 = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("ppc"),
        );
        const hasLeadEnquiry = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("lead"),
        );
        const hasHrRecruitment = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("recruitment"),
        );
        const hasHrAttendance = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("attendance"),
        );
        const hasPurchase = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("purchase"),
        );
        const hasLooms = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("looms"),
        );
        const hasTape = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("tape"),
        );
        const hasItc4 = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("itc-4"),
        );
        const hasExLamination = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("lamination"),
        );
        const hasFinishing1 = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("finishing-1"),
        );
        const hasFinishing2 = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("finishing-2"),
        );
        const hasGravure = tempMISData.some((feature) =>
          feature.fT_Name.toLowerCase().includes("gravure"),
        );

        const isVisible =
          (hasDesign && cardName.includes("design")) ||
          (hasSales && cardName.includes("sales")) ||
          (hasAuditTraining && cardName.includes("audit")) ||
          (hasInsurance && cardName.includes("insurance")) ||
          (hasDispatch && cardName.includes("dispatch")) ||
          (hasPPC1 && cardName.includes("ppc")) ||
          (hasLeadEnquiry && cardName.includes("lead")) ||
          (hasPurchase && cardName.includes("purchase")) ||
          (hasLooms && cardName.includes("looms")) ||
          (hasTape && cardName.includes("tape")) ||
          (hasItc4 && cardName.includes("itc-4")) ||
          (hasExLamination && cardName.includes("lamination")) ||
          (hasFinishing1 && cardName.includes("finishing-1")) ||
          (hasFinishing2 && cardName.includes("finishing-2")) ||
          (hasGravure && cardName.includes("gravure")) ||
          (hasHrRecruitment && cardName.includes("recruitment")) ||
          (hasHrAttendance && cardName.includes("attendance"));

        return { ...card, isVisible };
      });

      setCardData(updatedMISCardData);
    }
  }, [userApps]);

  const handleMouseEnter = (index) => {
    const updatedData = cardData.map((item, i) =>
      i === index ? { ...item, isHoverCard: true } : item,
    );
    setCardData(updatedData);
  };

  ///// mouse leave effect code
  const handleMouseLeave = (index) => {
    const updatedData = cardData.map((item, i) =>
      i === index ? { ...item, isHoverCard: false } : item,
    );
    setCardData(updatedData);
  };

  //// handle card click
  const handleCardClick = (card) => {
    // Find the MIS Dashboard app
    const misApp =
      userApps.find(
        (x) =>
          x.aP_Id === 14 || x.aP_Name.toLowerCase().includes("mis - dashboard"),
      ) || {};

    const applicationName = misApp.aP_Name || "";

    // Find the matching feature from login API based on card name
    let featureName = "";
    const tempMISData = misApp.features || [];
    const cardNameLower = card.name.toLowerCase();

    // Match card name with feature name from login API
    const matchingFeature = tempMISData.find((feature) => {
      const featureNameLower = feature.fT_Name.toLowerCase();
      if (cardNameLower.includes("design")) {
        return featureNameLower.includes("design");
      } else if (cardNameLower.includes("sales")) {
        return featureNameLower.includes("sales");
      } else if (cardNameLower.includes("audit")) {
        return featureNameLower.includes("audit");
      } else if (cardNameLower.includes("insurance")) {
        return featureNameLower.includes("insurance");
      } else if (cardNameLower.includes("dispatch")) {
        return featureNameLower.includes("dispatch");
      } else if (cardNameLower.includes("ppc")) {
        return featureNameLower.includes("ppc");
      } else if (
        cardNameLower.includes("lead") ||
        cardNameLower.includes("enquiry")
      ) {
        return (
          featureNameLower.includes("lead") ||
          featureNameLower.includes("enquiry")
        );
      } else if (cardNameLower.includes("recruitment")) {
        return featureNameLower.includes("recruitment");
      } else if (cardNameLower.includes("purchase")) {
        return featureNameLower.includes("purchase");
      } else if (cardNameLower.includes("looms")) {
        return featureNameLower.includes("looms");
      } else if (cardNameLower.includes("tape")) {
        return featureNameLower.includes("tape");
      } else if (cardNameLower.includes("itc-4")) {
        return featureNameLower.includes("itc-4");
      } else if (cardNameLower.includes("lamination")) {
        return featureNameLower.includes("lamination");
      } else if (cardNameLower.includes("finishing-1")) {
        return featureNameLower.includes("finishing-1");
      } else if (cardNameLower.includes("finishing-2")) {
        return featureNameLower.includes("finishing-2");
      } else if (cardNameLower.includes("gravure")) {
        return featureNameLower.includes("gravure");
      }
      return false;
    });

    featureName = matchingFeature ? matchingFeature.fT_Name : "";

    // Call Activity Log API
    const activityLogPayload = {
      featureName: featureName,
      applicationName: applicationName,
    };
    activityLogService.addActivityLogsAPI(activityLogPayload).catch((error) => {
      console.log(error, "Activity Log API Error");
    });

    navigate(card.pageUrl);
  };

  return (
    <Fragment>
      <div className="dashboard app-content content">
        <div className="content-wrapper">
          <div className="content-body">
            <div className="row">
              {cardData.map((item, i) => {
                return (
                  <>
                    {item.isVisible && (
                      <div className="col-xl-3 col-lg-6 col-12" key={i}>
                        <div
                          className={`card card-hover cur_point ${
                            item.isHoverCard ? "hovered" : ""
                          }`}
                          onClick={() => handleCardClick(item)}
                          onMouseEnter={() => handleMouseEnter(i)}
                          onMouseLeave={() => handleMouseLeave(i)}
                        >
                          <div className="card-content">
                            <div className="card-body d-flex justify-content-between card_text">
                              <img src={item.imageUrl} alt="img" />
                              <h4 className="text-info pt-15">{item.name}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MISDashboard;
